export default "__VITE_ASSET__DRVK33FL__"